export const UnsavedConfirmationMessage = "Do you want to leave this page?\nAll unsaved changes will be lost.";
export const DatePickerMaxYear = 2099;
export const FriendlyUrlMaxLength = 50;
export const MaxAuthorLength = 50;
export const MaxImageCaptionLength = 50;
export const SummaryMaxLength = 255;
export const TitleMaxLength = 50;
export const FriendlyUrlName_Pattern = "^[0-9a-zA-Z_-]+$";
export const friendlyUrlNameRegExp = new RegExp(FriendlyUrlName_Pattern);
export const FeedsPerPage = 1000;
